import { render, staticRenderFns } from "./classStart.vue?vue&type=template&id=12da7324&scoped=true"
import script from "./classStart.vue?vue&type=script&lang=js"
export * from "./classStart.vue?vue&type=script&lang=js"
import style0 from "./classStart.vue?vue&type=style&index=0&id=12da7324&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da7324",
  null
  
)

export default component.exports